import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { VerticalLayout1Module } from 'app/layout/vertical/layout-1/layout-1.module';
import { VerticalLayout2Module } from 'app/layout/vertical/layout-2/layout-2.module';
import { VerticalLayout3Module } from 'app/layout/vertical/layout-3/layout-3.module';
import { HorizontalLayout1Module } from 'app/layout/horizontal/layout-1/layout-1.module';

const COMPONENTS = [VerticalLayout1Module];

@NgModule({
  imports: [...COMPONENTS],
  exports: [...COMPONENTS, RouterModule],
})
export class LayoutModule {}
